// extracted by mini-css-extract-plugin
export default {"root":"list-options_root__LiVGk","list":"list-options_list__HJtA3"};